import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "../generic_components/SearchBar";
import HorizontalCards from "./HorizontalCards";
import { ChevronRight, ArrowLeft } from "@gravity-ui/icons";
import DiscoverPage from "./DiscoverPage";
import CardsCollection from "./CardsCollection";
import { useLocalState } from "../../contexts/LocalStateProvider";
import { usePostHog } from "posthog-js/react";
import { debounce } from "lodash";
import SmartAssistModal from "./SmartAssistModal";
import { getCookie } from "../../utils/cookieUtils";

import SongList from "./SongList";
import LoadingSongs from "./LoadingSongs";
import NoResultsFound from "./NoResultsFound";
import * as Sentry from "@sentry/react"
import { useAuth } from "../../contexts/AuthContext";
import { getPartitionedLocalStorage } from "../../utils/tokenExtraction";
const cards3 = [
  {
    id: 1,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Ads & Promos",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Ads & Promo.mp4",
  },
  {
    id: 2,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Arts & Crafts",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Arts & Crafts.mp4",
  },
  {
    id: 3,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Broadcasting",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Broadcasting.mp4",
  },
  {
    id: 4,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Cinematic",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Cinematic.mp4",
  },
  {
    id: 5,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Classical",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Classical Collection.mp4",
  },
  {
    id: 6,
    image: "/CircularPattern.svg?height=300&width=300",
    title: "Cooking",
    description: "This is a description for Card 1",
    filter: "Theme",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Cooking.mp4",
  },
  {
    id: 7,
    title: "Comedy",
    description: "This is a description for Card 1",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Comedy.mp4",
    filter: "Theme",
  },
  {
    id: 8,
    title: "Corporate",
    description: "This is a description for Card 1",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Corporate.mp4",
    filter: "Theme",
  },
  {
    id: 9,
    title: "Documentary",
    description: "This is a description for Card 1",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Documentary.mp4",
    filter: "Theme",
  },
  {
    id: 10,
    title: "Drama",
    description: "This is a description for Card 1",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Drama.mp4",
    filter: "Theme",
  },
  {
    id: 11,
    title: "Fashion",
    description: "This is a description for Card 1",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Fashion & Beauty.mp4",
    filter: "Theme",
  },
];

const genreCards = [
  {
    id: 1,
    image: "https://storage.googleapis.com/wubble-discover-files/Acoustic.png",
    title: "Acoustic",
    background:
      "[background:linear-gradient(135deg,#62491F_0%,#B59563_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Acoustic",
    filter: "Genre",
  },
  {
    id: 2,
    image: "https://storage.googleapis.com/wubble-discover-files/Ambient.png",
    title: "Ambient",
    background:
      "[background:linear-gradient(135deg,#E9C4C5_0%,#C4D6E9_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ambient",
    filter: "Genre",
  },
  {
    id: 3,
    image: "https://storage.googleapis.com/wubble-discover-files/Ballad.png",
    title: "Ballad",
    background:
      "[background:linear-gradient(135deg,#392822_0%,#392822_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ballad",
    filter: "Genre",
  },
  {
    id: 4,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Bedroom%20Pop.png",
    title: "Bedroom pop",
    background:
      " [background:linear-gradient(135deg,#898989_0%,#585858_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Bedroom Pop",
    filter: "Genre",
  },
  {
    id: 5,
    image: "https://storage.googleapis.com/wubble-discover-files/Beats.png",
    title: "Beats",
    background:
      "[background:linear-gradient(135deg,#554AA9_0%,#B985C2_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Bedroom Pop",
    filter: "Genre",
  },
  {
    id: 6,
    image: "https://storage.googleapis.com/wubble-discover-files/Blues.png",
    title: "Blues",
    background:
      " [background:linear-gradient(135deg,#B33C3E_0%,#763CB3_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Blues",
    filter: "Genre",
  },
  {
    id: 7,
    image: "https://storage.googleapis.com/wubble-discover-files/Chill.png",
    title: "Chill",
    background:
      "[background:linear-gradient(135deg,#4EBE2F_0%,#8D7B32_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Chill",
    filter: "Genre",
  },
  {
    id: 8,
    image: "https://storage.googleapis.com/wubble-discover-files/Children.png",
    title: "Children",
    background:
      "[background:linear-gradient(135deg,#B7123A_0%,#CD5BA6_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Children",
    filter: "Genre",
  },
  {
    id: 9,
    image: "https://storage.googleapis.com/wubble-discover-files/Cinematic.png",
    title: "Cinematic",
    background:
      "[background:linear-gradient(135deg,#2C7D94_0%,#02303D_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Cinematic",
    filter: "Genre",
  },
  {
    id: 10,
    image: "https://storage.googleapis.com/wubble-discover-files/Classical.png",
    title: "Classical",
    background:
      "[background:linear-gradient(135deg,#B8640A_0%,#3B1F01_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Classical",
    filter: "Genre",
  },
  {
    id: 11,
    image: "https://storage.googleapis.com/wubble-discover-files/Corporate.png",
    title: "Corporate",
    background:
      "[background:linear-gradient(135deg,#98ADBE_0%,#35A5FF_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Corporate",
    filter: "Genre",
  },
];

export const genreCollectionCards = [
  {
    id: 1,
    image: "https://storage.googleapis.com/wubble-discover-files/Acoustic.png",
    title: "Acoustic",
    background:
      "[background:linear-gradient(135deg,#62491F_0%,#B59563_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Acoustic",
    filter: "Genre",
  },
  {
    id: 2,
    image: "https://storage.googleapis.com/wubble-discover-files/Ambient.png",
    title: "Ambient",
    background:
      "[background:linear-gradient(135deg,#E9C4C5_0%,#C4D6E9_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ambient",
    filter: "Genre",
  },
  {
    id: 3,
    image: "https://storage.googleapis.com/wubble-discover-files/Ballad.png",
    title: "Ballad",
    background:
      "[background:linear-gradient(135deg,#392822_0%,#392822_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ballad",
    filter: "Genre",
  },
  {
    id: 4,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Bedroom%20Pop.png",
    title: "Bedroom pop",
    background:
      " [background:linear-gradient(135deg,#898989_0%,#585858_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Bedroom Pop",
    filter: "Genre",
  },
  {
    id: 5,
    image: "https://storage.googleapis.com/wubble-discover-files/Beats.png",
    title: "Beats",
    background:
      "[background:linear-gradient(135deg,#554AA9_0%,#B985C2_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Bedroom Pop",
    filter: "Genre",
  },
  {
    id: 6,
    image: "https://storage.googleapis.com/wubble-discover-files/Blues.png",
    title: "Blues",
    background:
      " [background:linear-gradient(135deg,#B33C3E_0%,#763CB3_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Blues",
    filter: "Genre",
  },
  {
    id: 7,
    image: "https://storage.googleapis.com/wubble-discover-files/Chill.png",
    title: "Chill",
    background:
      "[background:linear-gradient(135deg,#4EBE2F_0%,#8D7B32_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Chill",
    filter: "Genre",
  },
  {
    id: 8,
    image: "https://storage.googleapis.com/wubble-discover-files/Children.png",
    title: "Children",
    background:
      "[background:linear-gradient(135deg,#B7123A_0%,#CD5BA6_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Children",
    filter: "Genre",
  },
  {
    id: 9,
    image: "https://storage.googleapis.com/wubble-discover-files/Cinematic.png",
    title: "Cinematic",
    background:
      "[background:linear-gradient(135deg,#2C7D94_0%,#02303D_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Cinematic",
    filter: "Genre",
  },
  {
    id: 10,
    image: "https://storage.googleapis.com/wubble-discover-files/Classical.png",
    title: "Classical",
    background:
      "[background:linear-gradient(135deg,#B8640A_0%,#3B1F01_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Classical",
    filter: "Genre",
  },
  {
    id: 11,
    image: "https://storage.googleapis.com/wubble-discover-files/Corporate.png",
    title: "Corporate",
    background:
      "[background:linear-gradient(135deg,#98ADBE_0%,#35A5FF_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Corporate",
    filter: "Genre",
  },
  {
    id: 208,
    image: "https://storage.googleapis.com/wubble-discover-files/Country.png",
    title: "Country",
    background:
      "[background:linear-gradient(135deg,#98ADBE_0%,#35A5FF_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Country",
    filter: "Genre",
  },
  {
    id: 13,
    title: "Disco",
    image: "https://storage.googleapis.com/wubble-discover-files/Disco.png",
    background:
      "[background:linear-gradient(135deg,#4C3F6A_0%,#4C2A9B_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    filter: "Genre",
  },
  {
    id: 14,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Electronic.png",
    title: "Electronic",
    background:
      "[background:linear-gradient(135deg,#05720E_0%,#DB27DB_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Electronic",
    filter: "Genre",
  },
  {
    id: 15,
    image: "https://storage.googleapis.com/wubble-discover-files/Fantasy.png",
    title: "Fantasy",
    background:
      "[background:linear-gradient(135deg,#B0CCD9_0%,#87CCEB_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Fantasy",
    filter: "Genre",
  },
  {
    id: 16,
    image: "https://storage.googleapis.com/wubble-discover-files/Folk.png",
    title: "Folk",
    background:
      "[background:linear-gradient(135deg,#24340C_0%,#90A66F_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Folk",
    filter: "Genre",
  },
  {
    id: 17,
    image: "https://storage.googleapis.com/wubble-discover-files/Funk.png",
    title: "Funk",
    background:
      "[background:linear-gradient(135deg,#B55C17_0%,#760506_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Funk",
    filter: "Genre",
  },
  {
    id: 18,
    image: "https://storage.googleapis.com/wubble-discover-files/Hip%20Hop.png",
    title: "Hip Hop",
    background:
      "[background:linear-gradient(135deg,#21156D_0%,#841245_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Hip Hop",
    filter: "Genre",
  },
  {
    id: 19,
    image: "https://storage.googleapis.com/wubble-discover-files/Holiday.png",
    title: "Holiday",
    background:
      "[background:linear-gradient(135deg,#958679_0%,#E1C1A6_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Holiday",
    filter: "Genre",
  },
  {
    id: 20,
    image: "https://storage.googleapis.com/wubble-discover-files/Indie.png",
    title: "Indie",
    background:
      "[background:linear-gradient(135deg,#57737E_0%,#57737E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Indie",
    filter: "Genre",
  },
  {
    id: 21,
    image: "https://storage.googleapis.com/wubble-discover-files/Jazz.png",
    title: "Jazz",
    background:
      "[background:linear-gradient(135deg,#BE842F_0%,#9B610B_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Jazz",
    filter: "Genre",
  },
  {
    id: 22,
    image: "https://storage.googleapis.com/wubble-discover-files/Latin.png",
    title: "Latin",
    background:
      "[background:linear-gradient(135deg,#606060_0%,#3F372C_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Latin",
    filter: "Genre",
  },
  {
    id: 23,
    image: "https://storage.googleapis.com/wubble-discover-files/Lo-fi.png",
    title: "Lo-fi",
    background:
      "[background:linear-gradient(135deg,#6E2B3E_0%,#AB19BB_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Lo-fi Beats",
    filter: "Genre",
  },
  {
    id: 24,
    image: "https://storage.googleapis.com/wubble-discover-files/Lounge.png",
    title: "Lounge",
    background:
      "[background:linear-gradient(135deg,#71644C_0%,#7B898E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Lounge Pop",
    filter: "Genre",
  },
  {
    id: 25,
    image: "https://storage.googleapis.com/wubble-discover-files/Pop.png",
    title: "Pop",
    background:
      "[background:linear-gradient(135deg,#99BDB5_0%,#99BDB5_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Pop",
    filter: "Genre",
  },
  {
    id: 26,
    image: "https://storage.googleapis.com/wubble-discover-files/Raggae12.png",
    title: "Reggae",
    background:
      "[background:linear-gradient(135deg,#079578_0%,#21F6A8_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Reggae",
    filter: "Genre",
  },
  {
    id: 27,
    image: "https://storage.googleapis.com/wubble-discover-files/Retro.png",
    title: "Retro",
    background:
      "[background:linear-gradient(135deg,#433F43_0%,#433F43_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Retro",
    filter: "Genre",
  },
  {
    id: 28,
    image: "https://storage.googleapis.com/wubble-discover-files/Rock.png",
    title: "Rock",
    background:
      "[background:linear-gradient(135deg,#E76755_0%,#9438DE_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Rock",
    filter: "Genre",
  },
  {
    id: 29,
    image: "https://storage.googleapis.com/wubble-discover-files/RnB.png",
    title: "RnB",
    background:
      "[background:linear-gradient(135deg,#54322E_0%,#54322E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)] ",
    description: "This is a description for RnB",
    filter: "Genre",
  },
  {
    id: 30,
    image: "https://storage.googleapis.com/wubble-discover-files/Shoegaze.png",
    title: "Shoegaze",
    background:
      "[background:linear-gradient(135deg,#CE7266_0%,#CE7266_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Shoegaze",
    filter: "Genre",
  },
  {
    id: 31,
    image: "https://storage.googleapis.com/wubble-discover-files/Soul.png",
    title: "Soul",
    background:
      "[background:linear-gradient(0deg,rgba(16,15,16,0.60)_0%,rgba(16,15,16,0.10)_100%)]",
    description: "This is a description for Soul",
    filter: "Genre",
  },
  {
    id: 32,
    image: "https://storage.googleapis.com/wubble-discover-files/Swing.png",
    title: "Swing",
    background:
      "[background:linear-gradient(135deg,#91794A_0%,#91794A_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Swing",
    filter: "Genre",
  },
  {
    id: 33,
    image: "https://storage.googleapis.com/wubble-discover-files/Techno.png",
    title: "Techno",
    background:
      "[background:linear-gradient(135deg,#0E91A7_0%,#0E4BA7_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Techno",
    filter: "Genre",
  },
  {
    id: 34,
    image: "https://storage.googleapis.com/wubble-discover-files/World.png",
    title: "World",
    background:
      "[background:linear-gradient(135deg,#CF7B66_0%,#5B1A09_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for World",
    filter: "Genre",
  },
  {
    id: 35,
    image: "https://storage.googleapis.com/wubble-discover-files/Worship.png",
    title: "Worship",
    background:
      "[background:linear-gradient(135deg,#EFB849_0%,#8D6922_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Worship",
    filter: "Genre",
  },
];

const moodCards = [
  {
    id: 1,
    title: "Happy",
    description: "This is a description for Card 1",
    filter: "Mood",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Happy.mp4",
  },
  {
    id: 3,
    title: "Sentimental",
    description: "This is a description for Card 1",
    filter: "Mood",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Sentimental.mp4",
  },
  {
    id: 4,
    title: "Angry",
    description: "This is a description for Card 1",
    filter: "Mood",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Angry.mp4",
  },
  {
    id: 5,
    title: "Scary",
    description: "This is a description for Card 1",
    filter: "Mood",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Scary.mp4",
  },
  {
    id: 6,
    title: "Epic",
    description: "This is a description for Card 1",
    filter: "Mood",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Epic.mp4",
  },
  {
    id: 7,
    title: "Chasing",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Chasing.mp4",
    filter: "Mood",
  },
  {
    id: 8,
    title: "Chill",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Chill.mp4",
    filter: "Mood",
  },
  {
    id: 9,
    title: "Cozy",
    videoSrc: "https://storage.googleapis.com/wubble-discover-files/Cozy.mp4",
    filter: "Mood",
  },
  {
    id: 10,
    title: "Dramatic",
    videoSrc:
      "https://storage.googleapis.com/wubble-discover-files/Dramatic.mp4",
    filter: "Mood",
  },
];

export const moodCollectionCards = [
  {
    id: 1,
    title: "Angry",
    video: "https://storage.googleapis.com/wubble-discover-files/Angry.mp4",
    filter: "Mood",
  },
  {
    id: 2,
    title: "Bright",
    video: "https://storage.googleapis.com/wubble-discover-files/Bright 2.mp4",
    filter: "Mood",
  },
  {
    id: 3,
    title: "Busy",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Busy & Frantic.mp4",
    filter: "Mood",
  },
  {
    id: 4,
    title: "Calming",
    video: "https://storage.googleapis.com/wubble-discover-files/Calming.mp4",
    filter: "Mood",
  },
  {
    id: 5,
    title: "Carefree",
    video: "https://storage.googleapis.com/wubble-discover-files/Carefree.mp4",
    filter: "Mood",
  },
  {
    id: 7,
    title: "Chasing",
    video: "https://storage.googleapis.com/wubble-discover-files/Chasing.mp4",
    filter: "Mood",
  },
  {
    id: 8,
    title: "Chill",
    video: "https://storage.googleapis.com/wubble-discover-files/Chill.mp4",
    filter: "Mood",
  },
  {
    id: 9,
    title: "Cozy",
    video: "https://storage.googleapis.com/wubble-discover-files/Cozy.mp4",
    filter: "Mood",
  },
  {
    id: 11,
    title: "Dramatic",
    video: "https://storage.googleapis.com/wubble-discover-files/Dramatic.mp4",
    filter: "Mood",
  },
  {
    id: 12,
    title: "Dreamy",
    video: "https://storage.googleapis.com/wubble-discover-files/Dreamy.mp4",
    filter: "Mood",
  },
  {
    id: 13,
    title: "Eccentric",
    video: "https://storage.googleapis.com/wubble-discover-files/Eccentric.mp4",
    filter: "Mood",
  },
  {
    id: 14,
    title: "Elegant",
    video: "https://storage.googleapis.com/wubble-discover-files/Elegant.mp4",
    filter: "Mood",
  },
  {
    id: 15,
    title: "Energetic",
    video: "https://storage.googleapis.com/wubble-discover-files/Energetic.mp4",
    filter: "Mood",
  },
  {
    id: 16,
    title: "Epic",
    video: "https://storage.googleapis.com/wubble-discover-files/Epic.mp4",
    filter: "Mood",
  },
  {
    id: 17,
    title: "Euphoric",
    video: "https://storage.googleapis.com/wubble-discover-files/Euphoric.mp4",
    filter: "Mood",
  },
  {
    id: 18,
    title: "Fear",
    video: "https://storage.googleapis.com/wubble-discover-files/Fear.mp4",
    filter: "Mood",
  },
  {
    id: 19,
    title: "Floating",
    video: "https://storage.googleapis.com/wubble-discover-files/Floating.mp4",
    filter: "Mood",
  },
  {
    id: 20,
    title: "Funny",
    video: "https://storage.googleapis.com/wubble-discover-files/Funny.mp4",
    filter: "Mood",
  },
  {
    id: 20,
    title: "Glamorous",
    video: "https://storage.googleapis.com/wubble-discover-files/Glamorous.mp4",
    filter: "Mood",
  },
  {
    id: 22,
    title: "Groovy",
    video: "https://storage.googleapis.com/wubble-discover-files/Groovy.mp4",
    filter: "Mood",
  },
  {
    id: 23,
    title: "Grunge",
    video: "https://storage.googleapis.com/wubble-discover-files/Grunge.mp4",
    filter: "Mood",
  },
  {
    id: 24,
    title: "Happy",
    video: "https://storage.googleapis.com/wubble-discover-files/Happy.mp4",
    filter: "Mood",
  },
  {
    id: 25,
    title: "Heavy",
    video: "https://storage.googleapis.com/wubble-discover-files/Heavy.mp4",
    filter: "Mood",
  },
  {
    id: 27,
    title: "Hopeful",
    video: "https://storage.googleapis.com/wubble-discover-files/Hopeful.mp4",
    filter: "Mood",
  },
  {
    id: 29,
    title: "Laid back",
    video: "https://storage.googleapis.com/wubble-discover-files/Laid Back.mp4",
    filter: "Mood",
  },
  {
    id: 30,
    title: "Love",
    video: "https://storage.googleapis.com/wubble-discover-files/Love.mp4",
    filter: "Mood",
  },
  {
    id: 300,
    title: "Marching",
    video: "https://storage.googleapis.com/wubble-discover-files/Marching.mp4",
    filter: "Mood",
  },
  {
    id: 32,
    title: "Melancholic",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Melancholic.mp4",
    filter: "Mood",
  },
  {
    id: 33,
    title: "Mysterious",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Mysterious-1.mp4",
    filter: "Mood",
  },
  {
    id: 34,
    title: "Peaceful",
    video: "https://storage.googleapis.com/wubble-discover-files/Peaceful.mp4",
    filter: "Mood",
  },
  {
    id: 35,
    title: "Playful",
    video: "https://storage.googleapis.com/wubble-discover-files/Playful.mp4",
    filter: "Mood",
  },
  {
    id: 36,
    title: "Powerful",
    video: "https://storage.googleapis.com/wubble-discover-files/Powerful.mp4",
    filter: "Mood",
  },
  {
    id: 37,
    title: "Quirky",
    video: "https://storage.googleapis.com/wubble-discover-files/Quirky.mp4",
    filter: "Mood",
  },
  {
    id: 38,
    title: "Relaxing",
    video: "https://storage.googleapis.com/wubble-discover-files/Relaxing.mp4",
    filter: "Mood",
  },
  {
    id: 39,
    title: "Restless",
    video: "https://storage.googleapis.com/wubble-discover-files/Restless.mp4",
    filter: "Mood",
  },
  {
    id: 43,
    title: "Scary",
    video: "https://storage.googleapis.com/wubble-discover-files/Scary.mp4",
    filter: "Mood",
  },
  {
    id: 44,
    title: "Sentimental",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Sentimental.mp4",
    filter: "Mood",
  },
  {
    id: 45,
    title: "Serious",
    video: "https://storage.googleapis.com/wubble-discover-files/Serious.mp4",
    filter: "Mood",
  },
  {
    id: 46,
    title: "Sexy",
    video: "https://storage.googleapis.com/wubble-discover-files/Sexy.mp4",
    filter: "Mood",
  },
  {
    id: 47,
    title: "Smooth",
    video: "https://storage.googleapis.com/wubble-discover-files/Smooth.mp4",
    filter: "Mood",
  },
  {
    id: 48,
    title: "Sneaking",
    video: "https://storage.googleapis.com/wubble-discover-files/Sneaking.mp4",
    filter: "Mood",
  },
  {
    id: 49,
    title: "Soft",
    video: "https://storage.googleapis.com/wubble-discover-files/Soft.mp4",
    filter: "Mood",
  },
  {
    id: 50,
    title: "Suspense",
    video: "https://storage.googleapis.com/wubble-discover-files/Suspense.mp4",
    filter: "Mood",
  },
  {
    id: 51,
    title: "Tense",
    video: "https://storage.googleapis.com/wubble-discover-files/Tense.mp4",
    filter: "Mood",
  },
  {
    id: 52,
    title: "Uplifting",
    video: "https://storage.googleapis.com/wubble-discover-files/Uplifting.mp4",
    filter: "Mood",
  },
  {
    id: 53,
    title: "Weird",
    video: "https://storage.googleapis.com/wubble-discover-files/Weird.mp4",
    filter: "Mood",
  },
];

const instrumentCards = [
  {
    id: 1,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Acoustic Guitar.png",
    title: "Acoustic Guitar",
    background:
      "[background:linear-gradient(135deg,#180A08_0%,#BE331F_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 2,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Acoustic Drums.png",
    title: "Drums",
    background:
      "[background:linear-gradient(135deg,#B6948A_0%,#AE9167_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 3,
    image: "https://storage.googleapis.com/wubble-discover-files/Banjo.png",
    title: "Banjo",
    background:
      "[background:linear-gradient(135deg,#2C3931_0%,#415C4C_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 4,
    image: "https://storage.googleapis.com/wubble-discover-files/Bass.png",
    title: "Bass",
    background:
      "[background:linear-gradient(135deg,#B9B9B9_0%,#2B2B2B_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 5,
    image: "https://storage.googleapis.com/wubble-discover-files/Bells.png",
    title: "Bells",
    background:
      "[background:linear-gradient(135deg,#A78357_0%,#805C30_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 6,
    image: "https://storage.googleapis.com/wubble-discover-files/Brass.png",
    title: "Brass",
    background:
      "[background:linear-gradient(135deg,#816F5E_0%,#D8BC5E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 600,
    image: "https://storage.googleapis.com/wubble-discover-files/Clap.png",
    title: "Clap",
    background:
      "[background:linear-gradient(135deg,#816F5E_0%,#D8BC5E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 8,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Electric Guitar.png",
    title: "Electric Guitar",
    background:
      "[background:linear-gradient(135deg,#8D7B32_0%,#736735_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Electric Guitar",
    filter: "Instrument",
  },
  {
    id: 9,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Electronic Drums.png",
    title: "Electric Drums",
    background:
      "[background:linear-gradient(135deg,#4D0561_0%,#430431_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Electronic Drums",
    filter: "Instrument",
  },
  {
    id: 10,
    image: "https://storage.googleapis.com/wubble-discover-files/Ethnic.png",
    title: "Ethnic",
    background:
      "[background:linear-gradient(135deg,#5B2C0F_0%,#E3712A_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ethnic instruments",
    filter: "Instrument",
  },
  {
    id: 11,
    image: "https://storage.googleapis.com/wubble-discover-files/Keys.png",
    title: "Keys",
    background:
      "[background:linear-gradient(135deg,#A5A7AC_0%,#A5A7AC_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Keys",
    filter: "Instrument",
  },
];

export const instrumentCollectionCards = [
  {
    id: 1,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Acoustic Guitar.png",
    title: "Acoustic Guitar",
    background:
      "[background:linear-gradient(135deg,#180A08_0%,#BE331F_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 2,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Acoustic Drums.png",
    title: "Drums",
    background:
      "[background:linear-gradient(135deg,#B6948A_0%,#AE9167_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 3,
    image: "https://storage.googleapis.com/wubble-discover-files/Banjo.png",
    title: "Banjo",
    background:
      "[background:linear-gradient(135deg,#2C3931_0%,#415C4C_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 4,
    image: "https://storage.googleapis.com/wubble-discover-files/Bass.png",
    title: "Bass",
    background:
      "[background:linear-gradient(135deg,#B9B9B9_0%,#2B2B2B_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 5,
    image: "https://storage.googleapis.com/wubble-discover-files/Bells.png",
    title: "Bells",
    background:
      "[background:linear-gradient(135deg,#A78357_0%,#805C30_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 6,
    image: "https://storage.googleapis.com/wubble-discover-files/Brass.png",
    title: "Brass",
    background:
      "[background:linear-gradient(135deg,#816F5E_0%,#D8BC5E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 600,
    image: "https://storage.googleapis.com/wubble-discover-files/Clap.png",
    title: "Clap",
    background:
      "[background:linear-gradient(135deg,#816F5E_0%,#D8BC5E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Card 1",
    filter: "Instrument",
  },
  {
    id: 8,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Electric Guitar.png",
    title: "Electric Guitar",
    background:
      "[background:linear-gradient(135deg,#8D7B32_0%,#736735_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Electric Guitar",
    filter: "Instrument",
  },
  {
    id: 9,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Electronic Drums.png",
    title: "Electric Drums",
    background:
      "[background:linear-gradient(135deg,#4D0561_0%,#430431_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Electronic Drums",
    filter: "Instrument",
  },
  {
    id: 10,
    image: "https://storage.googleapis.com/wubble-discover-files/Ethnic.png",
    title: "Ethnic",
    background:
      "[background:linear-gradient(135deg,#5B2C0F_0%,#E3712A_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Ethnic instruments",
    filter: "Instrument",
  },
  {
    id: 11,
    image: "https://storage.googleapis.com/wubble-discover-files/Keys.png",
    title: "Keys",
    background:
      "[background:linear-gradient(135deg,#A5A7AC_0%,#A5A7AC_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Keys",
    filter: "Instrument",
  },
  {
    id: 12,
    image: "https://storage.googleapis.com/wubble-discover-files/Mandolin.png",
    title: "Mandolin",
    background:
      " [background:linear-gradient(135deg,#6550BD_0%,#6550BD_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)",
    description: "This is a description for Mandolin",
    filter: "Instrument",
  },
  {
    id: 14,
    image: "https://storage.googleapis.com/wubble-discover-files/Orchestra.png",
    title: "Orchestra",
    background:
      "[background:linear-gradient(135deg,#7A2209_0%,#B83611_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Orchestra",
    filter: "Instrument",
  },
  {
    id: 15,
    image: "https://storage.googleapis.com/wubble-discover-files/Pads.png",
    title: "Pads",
    background:
      "[background:linear-gradient(135deg,#7E4A5C_0%,#544A7E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Pads",
    filter: "Instrument",
  },
  {
    id: 17,
    image: "https://storage.googleapis.com/wubble-discover-files/Piano.png",
    title: "Piano",
    background:
      "[background:linear-gradient(135deg,#1B0C08_0%,#9D2404_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Piano",
    filter: "Instrument",
  },
  {
    id: 18,
    image: "https://storage.googleapis.com/wubble-discover-files/Saxophone.png",
    title: "Saxaphone",
    background:
      "[background:linear-gradient(135deg,#8D693B_0%,#EDAB56_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Saxophone",
    filter: "Instrument",
  },
  {
    id: 19,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Wind Instruments.png",
    title: "Wind Instruments",
    background:
      "[background:linear-gradient(135deg,#B29680_0%,#CCA78A_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Special Wind Instruments",
    filter: "Instrument",
  },
  {
    id: 20,
    image: "https://storage.googleapis.com/wubble-discover-files/Strings.png",
    title: "Strings",
    background:
      "[background:linear-gradient(135deg,#657258_0%,#455B2E_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Strings",
    filter: "Instrument",
  },
  {
    id: 21,
    image: "https://storage.googleapis.com/wubble-discover-files/Synth.png",
    title: "Synth",
    background:
      "[background:linear-gradient(135deg,#6F8998_0%,#063D75_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Synth",
    filter: "Instrument",
  },
  {
    id: 22,
    image: "https://storage.googleapis.com/wubble-discover-files/Trumpets.png",
    title: "Trumpets",
    background:
      "[background:linear-gradient(135deg,#C85E50_0%,#A22211_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Trumpets",
    filter: "Instrument",
  },
  {
    id: 23,
    image:
      "https://storage.googleapis.com/wubble-discover-files/Upright Bass.png",
    title: "Upright bass",
    background:
      "[background:linear-gradient(135deg,#7C7C50_0%,#5B5B26_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Upright Bass",
    filter: "Instrument",
  },
  {
    id: 24,
    image: "https://storage.googleapis.com/wubble-discover-files/Violin.png",
    title: "Violin",
    background:
      "[background:linear-gradient(135deg,#053957_0%,#777E90_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Violin",
    filter: "Instrument",
  },
  {
    id: 26,
    image: "https://storage.googleapis.com/wubble-discover-files/Woodwinds.png",
    title: "Woodwinds",
    background:
      "[background:linear-gradient(135deg,#B28938_0%,#2F6321_100%)] shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15),0px_-4px_10px_0px_rgba(0,0,0,0.15)]",
    description: "This is a description for Woodwinds",
    filter: "Instrument",
  },
];

export const themeCards = [
  {
    id: 1,
    title: "Ads & Promos",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Ads & Promo.mp4",
    filter: "Theme",
  },
  {
    id: 2,
    title: "Arts & Crafts",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Arts & Crafts.mp4",
    filter: "Theme",
  },
  {
    id: 3,
    title: "Broadcasting",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Broadcasting.mp4",
    filter: "Theme",
  },
  {
    id: 4,
    title: "Cinematic",
    video: "https://storage.googleapis.com/wubble-discover-files/Cinematic.mp4",
    filter: "Theme",
  },
  {
    id: 5,
    title: "Classical",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Classical Collection.mp4",
    filter: "Theme",
  },
  {
    id: 6,
    title: "Cooking",
    video: "https://storage.googleapis.com/wubble-discover-files/Cooking.mp4",
    filter: "Theme",
  },
  {
    id: 200,
    title: "Comedy",
    video: "https://storage.googleapis.com/wubble-discover-files/Comedy.mp4",
    filter: "Theme",
  },
  {
    id: 7,
    title: "Corporate",
    video: "https://storage.googleapis.com/wubble-discover-files/Corporate.mp4",
    filter: "Theme",
  },
  {
    id: 8,
    title: "Documentary",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Documentary.mp4",
    filter: "Theme",
  },
  {
    id: 9,
    title: "Drama",
    video: "https://storage.googleapis.com/wubble-discover-files/Drama.mp4",
    filter: "Theme",
  },
  {
    id: 10,
    title: "Fashion",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Fashion & Beauty.mp4",
    filter: "Theme",
  },
  {
    id: 11,
    title: "Gaming",
    video: "https://storage.googleapis.com/wubble-discover-files/Gaming.mp4",
    filter: "Theme",
  },
  {
    id: 12,
    title: "Holiday",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Holiday Seasons.mp4",
    filter: "Theme",
  },
  {
    id: 13,
    title: "Horror",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Horror & Thriller.mp4",
    filter: "Theme",
  },
  {
    id: 14,
    title: "Motivational",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Motivation & Inspiring.mp4",
    filter: "Theme",
  },
  {
    id: 15,
    title: "Nature",
    video: "https://storage.googleapis.com/wubble-discover-files/Nature.mp4",
    filter: "Theme",
  },
  {
    id: 16,
    title: "Photography",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Photography.mp4",
    filter: "Theme",
  },
  {
    id: 17,
    title: "Podcast",
    video: "https://storage.googleapis.com/wubble-discover-files/Podcast.mp4",
    filter: "Theme",
  },
  {
    id: 18,
    title: "Storytelling",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Storytelling Techniques.mp4",
    filter: "Theme",
  },
  {
    id: 19,
    title: "Sports",
    video: "https://storage.googleapis.com/wubble-discover-files/Sports.mp4",
    filter: "Theme",
  },
  {
    id: 20,
    title: "Technology",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Technology.mp4",
    filter: "Theme",
  },
  {
    id: 21,
    title: "Travel",
    video: "https://storage.googleapis.com/wubble-discover-files/Travel.mp4",
    filter: "Theme",
  },
  {
    id: 22,
    title: "Tutorial",
    video: "https://storage.googleapis.com/wubble-discover-files/Tutorials.mp4",
    filter: "Theme",
  },
  {
    id: 23,
    title: "Vlogs",
    video: "https://storage.googleapis.com/wubble-discover-files/Vlogs.mp4",
    filter: "Theme",
  },
  {
    id: 24,
    title: "Romance",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Wedding & Romance.mp4",
    filter: "Theme",
  },
  {
    id: 25,
    title: "Wellness",
    video:
      "https://storage.googleapis.com/wubble-discover-files/Workout & Wellness.mp4",
    filter: "Theme",
  },
];

const Discover = () => {
  const posthog = usePostHog();
  const [searchTerm, setSearchTerm] = useState("");
  const [showDiscoverPage, setShowDiscoverPage] = useState(false);
  const [showThemesPage, setShowThemesPage] = useState(false);
  const [showMoodsPage, setShowMoodsPage] = useState(false);
  const [showGenresPage, setShowGenresPage] = useState(false);
  const [showInstrumentsPage, setShowInstrumentsPage] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const { updateLocalState, localState } = useLocalState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    themes: [],
    moods: [],
    genres: [],
    instruments: [],
  });
  const [isSmartAssistOpen, setIsSmartAssistOpen] = useState(false);
  const [forYouTracks, setForYouTracks] = useState([]);
  const [showForYouDiscoverPage, setShowForYouDiscoverPage] = useState(false);
  const [isForYouLoading, setIsForYouLoading] = useState(true);
  const { isLoggedIn } = useAuth();
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleSearch = (value) => {
    if(!searchTerm && value){
      posthog.capture("Type-SearchBar-DiscoverMainPage", {
        is_user_logged_in: isLoggedIn ? true : false
      })
    }
    setSearchTerm(value);
  }

  const handleFilterSelection = async () => {
    const response = await apiService.fetchSongs(selectedFilters);
    // ... existing logic to display songs ...
  };

  const formatDuration = (seconds) => {
    if (typeof seconds !== 'number' || isNaN(seconds)) {
      return "0:00"; // Default or error value
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60); // Use Math.floor to ensure integer
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const fetchSearchResults = async (term) => {
    if (!term || term.trim() === "") {
      setSearchResults([]); // Clear results if search term is empty or just whitespace
      setIsSearching(false);
      setApiError(null); // Clear any previous errors
      return;
    }
    setIsSearching(true);
    setApiError(null); // Reset error state
    console.log(`[Frontend] Searching for term: ${term}`); // Log search term
    try {
      const userId = isLoggedIn ? getCookie("user_id") || getPartitionedLocalStorage("user_id") : null;
      const queryParams = new URLSearchParams({
        title: term, // Search primarily by title
        description: term, // Optionally search description too
        // Let's try searching genre/mood etc as well for broader matching
        genre: term,
        mood: term,
        theme: term,
        instrument: term,
        limit: 20, // Fetch a reasonable number of results
        offset: 0,
        userId: userId,
      });

      const response = await fetch(
        `${process.env.REACT_APP_SERVER_ENDPOINT}/api/discover-search?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Include auth header if needed
            // Authorization: `Bearer ${getCookie("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("[Frontend] Raw API response received:", data); // Log raw API response

      // Process results to match SongList format
      const processedData = data.results.map((song) => ({
        id: song.id,
        name: song.title.replace(/ V2$/, ''), // Remove " V2" from the end of the title
        fileName: song.file_name,
        creator: "Unknown Artist", // Adjust if creator info is available
        duration: formatDuration(song.duration),
        audioSrc: `${process.env.REACT_APP_SERVER_ENDPOINT}/api/stream-discover-audio/${song.file_name}`, // Ensure this endpoint works for search results
        image: `https://storage.googleapis.com/wubble-discover-files/${song.image_name}`, // Adjust image path if needed
        genre: song.genre,
        mood: song.mood,
        theme: song.themes,
        instrument: song.instrument,
        description: song.description,
        isLiked: song.is_liked,
        waveformData: song.waveform,
        displayTags: [song.genre, song.mood, song.themes, song.instrument]
          .filter(Boolean) // Remove null/undefined tags
          .join(" . "), // Create tags string
      }));
      console.log("[Frontend] Processed search results:", processedData); // Log processed data

      setSearchResults(processedData);
      posthog.capture("Discover Intro Search successful", {is_user_logged_in: isLoggedIn ? true : false,  searchTerm: term, resultCount: processedData.length });

    } catch (error) {
      console.error("Error fetching search results:", error);
      Sentry.captureException(error);
      setApiError("Failed to fetch search results. Please try again."); // Set user-friendly error state
      setSearchResults([]); // Clear results on error
      posthog.capture("Discover Intro Search failed", { is_user_logged_in: isLoggedIn ? true : false, searchTerm: term, error: error.message });
    } finally {
      setIsSearching(false);
    }
  };

  const debouncedFetchSearchResults = useCallback(
    debounce(fetchSearchResults, 400), // Debounce time in ms (e.g., 400ms)
    [isLoggedIn] // Dependencies for useCallback
  );

  useEffect(() => {
    debouncedFetchSearchResults(searchTerm);

    // Cleanup function to cancel any pending debounced calls if the component unmounts or searchTerm changes quickly
    return () => {
      debouncedFetchSearchResults.cancel();
    };
  }, [searchTerm, debouncedFetchSearchResults]);

  useEffect(() => {
    const fetchForYouTracks = async () => {
      try {
        const token = getCookie("token") || getPartitionedLocalStorage("token"); // Get the token from cookies
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_ENDPOINT}/api/recommended-tracks`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch For You tracks");
        }

        const result = await response.json();

        // Construct the forYouTracks with the required properties
        const processedTracks = result.flatMap((trackCategory) => {
          if (trackCategory.tracks.length === 0) {
            return []; // Skip empty tracks
          }
          return trackCategory.tracks.map((track) => {
            const tags = [
              track.genre,
              track.mood,
              track.themes,
              track.instrument,
            ];

            return {
              id: track.id,
              title: track.title, // Keep original title
              name: track.title.replace(/ V2$/, ''), // Use cleaned name for display/player
              fileName: track.file_name,
              description: tags.join(" . "),
              duration: formatDuration(track.duration),
              audioSrc: `${process.env.REACT_APP_SERVER_ENDPOINT}/api/stream-discover-audio/${track.file_name}`,
              image: `https://storage.googleapis.com/wubble-discover-files/${track.image_name}`,
              genre: track.genre,
              mood: track.mood,
              theme: track.themes,
              instrument: track.instrument,
              isLiked: track.is_liked,
              displayTags: tags.join(" . "),
              waveformData: track.waveform,
            };
          });
        });
        setForYouTracks(processedTracks); // Set the processed tracks to state
        updateLocalState("forYouTracks", processedTracks);
      } catch (error) {
        console.error("Error fetching For You tracks:", error);
        Sentry.captureException(error);
      } finally {
        setIsForYouLoading(false);
      }
    };

    if (localState.forYouTracks) {
      setForYouTracks(localState.forYouTracks);
      setIsForYouLoading(false);
    } else if (isLoggedIn && !searchTerm) { // Only fetch if logged in and not searching
      fetchForYouTracks();
    } else {
        setIsForYouLoading(false); // Ensure loading state is false if not fetching
    }
    // Make sure dependencies are correct, add searchTerm if its change should refetch 'For You' (likely not needed)
  }, [localState.forYouTracks, isLoggedIn, searchTerm]); // Added searchTerm

  useEffect(() => {
    localState.isAudioPlaying
      ? setIsAudioPlaying(true)
      : setIsAudioPlaying(false);
  }, [localState.isAudioPlaying]);

  // const handleExploreAllTracks = () => {
  //   posthog.capture("Explore All Tracks");
  //   setSelectedCard(null);

  //   setShowDiscoverPage(true);
  // };

  const handleExploreAllThemes = () => {
    posthog.capture("Explore All Themes", {
      is_user_logged_in: isLoggedIn ? true : false
    });
    setShowThemesPage(true);
  };

  const handleCardClick = (card) => {
    posthog.capture("Click Discover Page Category", { is_user_logged_in: isLoggedIn ? true : false, card: card });
    setSelectedCard(card);
    setShowDiscoverPage(true);
  };

  const handleExploreForYouTracks = () => {
    // posthog.capture("Explore For You Tracks");
    setShowForYouDiscoverPage(true);
  };

  const renderContent = () => {
    if (searchTerm) {
      // Search term exists - show search results or status
      return (
        <div className="w-full h-full p-1.5"> {/* Padding for search results consistency */}
          {isSearching ? (
            <LoadingSongs itemCount={5} /> // Show loading state
          ) : apiError ? (
            <div className="flex items-center justify-center h-full text-gray-500"> {/* Centered Error */}
              {apiError}
            </div>
          ) : searchResults.length > 0 ? (
            <SongList songs={searchResults} /> // Show results using SongList
          ) : (
            <NoResultsFound 
              onClearFilters={() => setSearchTerm("")} 
              showTips={true} // Pass showTips prop here
            /> // Show no results message
          )}
        </div>
      );
    } else {
      // No search term - show default category cards
      return (
        <>
          {isLoggedIn && ((isForYouLoading) || localState.forYouTracks?.length > 0) && (
            <HorizontalCards
              cardType="standard"
              data={localState.forYouTracks?.slice(0, 11)}
              title="For you"
              exploreMoreText="Explore more tracks"
              onExploreClick={handleExploreForYouTracks}
              isLoading={isForYouLoading}
            />
          )}
          <HorizontalCards
            cardType="video"
            data={cards3} // Themes
            title="Theme"
            exploreMoreText={"Explore themes"}
            onCardClick={handleCardClick}
            onExploreClick={handleExploreAllThemes}
            isLoading={!cards3 || cards3.length === 0} 

          />
          <HorizontalCards
            cardType="vinyl"
            data={genreCards} // Genres
            title="Genre"
            exploreMoreText={"Explore genres"}
            onCardClick={handleCardClick}
            onExploreClick={() => {
              posthog.capture("Explore All Genres", {is_user_logged_in: isLoggedIn ? true : false});
              setShowGenresPage(true);
            }}
            isLoading={!genreCards || genreCards.length === 0} 

          />
          <HorizontalCards
            cardType="video"
            data={moodCards} // Moods
            title="Mood"
            exploreMoreText={"Explore moods"}
            onCardClick={handleCardClick}
            onExploreClick={() => {
              posthog.capture("Explore All Moods", {
                is_user_logged_in: isLoggedIn ? true : false
              });
              setShowMoodsPage(true);
            }}
            isLoading={!moodCards || moodCards.length === 0} 

          />
          <HorizontalCards
            cardType="vinyl"
            data={instrumentCards} // Instruments
            title="Instrument"
            exploreMoreText={"Explore instruments"}
            onCardClick={handleCardClick}
            onExploreClick={() => {
              posthog.capture("Explore All Instruments", {
                is_user_logged_in: isLoggedIn ? true : false
              });
              setShowInstrumentsPage(true);
            }}
            isLoading={!instrumentCards || instrumentCards.length === 0} 

          />
        </>
      );
    }
  };

  if (showThemesPage && !showDiscoverPage) {
    return (
      <CardsCollection
        cards={themeCards}
        title="All Themes"
        onGoBackClick={() => setShowThemesPage(false)}
        onCardClick={handleCardClick}
      />
    );
  }

  if (showGenresPage && !showDiscoverPage) {
    return (
      <CardsCollection
        cards={genreCollectionCards}
        title="All Genres"
        onGoBackClick={() => setShowGenresPage(false)}
        cardType="vinyl"
        onCardClick={handleCardClick}
      />
    );
  }

  if (showMoodsPage && !showDiscoverPage) {
    return (
      <CardsCollection
        cards={moodCollectionCards}
        title="All Moods"
        onGoBackClick={() => setShowMoodsPage(false)}
        cardType="video"
        onCardClick={handleCardClick}
      />
    );
  }

  if (showInstrumentsPage && !showDiscoverPage) {
    return (
      <CardsCollection
        cards={instrumentCollectionCards}
        title="All Instruments"
        onGoBackClick={() => setShowInstrumentsPage(false)}
        cardType="vinyl"
        onCardClick={handleCardClick}
      />
    );
  }

  if (showDiscoverPage && selectedCard) {
    return (
      <DiscoverPage
        card={{
          image: selectedCard.image,
          background: selectedCard.background,
        }}
        video={selectedCard?.video || selectedCard?.videoSrc}
        description={selectedCard.description}
        title={selectedCard.title} // This title is for the DiscoverPage header, not the player
        filter={selectedCard.filter}
        onGoBackClick={() => setShowDiscoverPage(false)}
      />
    );
  }

  if (showForYouDiscoverPage) {
    posthog.capture("Click on Explore For you tracks", {
      is_user_logged_in: isLoggedIn ? true : false
    });
    return (
      <DiscoverPage
        forYouTracks={localState.forYouTracks} // These tracks now have their 'name' property cleaned
        onGoBackClick={() => setShowForYouDiscoverPage(false)}
      />
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex w-full px-4">
        <div className="w-full hidden md:block relative mt-4 h-[9rem] overflow-hidden">
          {/* Pseudo-element for rounded border */}
          <div className="absolute inset-0 rounded-t-lg pointer-events-none darker-filter [background:linear-gradient(135deg,#8CD9D3_0%,#5F81B5_100%)] z-10"></div>

          {/* Folder SVG in the center with lower z-index */}
          <div className="absolute -bottom-[9rem] left-1/2 -translate-x-1/2 flex items-center justify-center z-10">
            <img
              src="/Subtract.svg"
              alt="Subtract Icon"
              className="w-[16rem] h-[16rem] animate-slow-rotate-left"
            />
          </div>

          {/* right circles */}
          <div className="absolute -top-[23rem] -right-[26rem] w-[45rem] h-[45rem] bg-[#7A1998] opacity-[0.15] bg-blend-hard-light mix-blend-hard-light rounded-full animate-slow-move-reverse z-20" />
          <div className="absolute -bottom-[35rem] -right-[10rem] w-[45rem] h-[45rem] bg-[#7A1998] opacity-[0.15] bg-blend-hard-light mix-blend-hard-light rounded-full animate-slow-move-reverse z-20" />

          {/* left circles */}
          <div className="absolute -bottom-80 -left-[40rem] w-[56rem] h-[56rem] bg-[#7A1998] opacity-[0.15] bg-blend-hard-light mix-blend-hard-light rounded-full animate-slow-move z-20" />
          <div className="absolute -bottom-[42rem] -left-[10em] w-[48rem] h-[48rem] bg-[#7A1998] opacity-[0.15] bg-blend-hard-light mix-blend-hard-light rounded-full animate-slow-move z-20" />

          {/* Bottom-left title */}
          <h1 className="absolute bottom-6 left-5 text-4xl font-normal text-white z-20">
            Discover
          </h1>
        </div>
      </div>

      <div className=" hidden md:flex justify-end px-4 py-3">
      <SearchBar
        placeholder="Search song by name, mood, genre..."
        className="bg-transparent w-full text-sm font-extralight placeholder-[#878188] h-9 rounded-full border border-solid border-white/10 focus:border-white/20 focus:border-2 focus:outline-none appearance-none focus:ring-0"
        value={searchTerm}
        onSearch={handleSearch}
        onClear={() => setSearchTerm("")}
        fromDiscover={true}
        onVisibilityChange={true}
      />

      </div>
      <div className="w-full border-t border-t-[#2C2A2C]"></div>

      <div
        className={`flex flex-col ${
          isAudioPlaying
            ? `md:max-h-[calc(100vh-310px)] max-h-[calc(100vh-214px)] `
            : `md:max-h-[calc(100vh-240px)] max-h-[calc(100vh-148px)]`
        } scrollable-content h-full overflow-y-auto`}
      >
        {isSmartAssistOpen && (
          <SmartAssistModal onClose={() => setIsSmartAssistOpen(false)} />
        )}

        {renderContent()}

      </div>
    </div>
  );
};

export default Discover;
